import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Facebook, Send, Loader2, Save } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Admin: Meta Pixel / Conversions API status, test-event code and a one-click test event. */
export default function AdminMetaPixelCard() {
  const [s, setS] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const r = await axios.get(`${API}/meta/admin/status`); setS(r.data); setCode(r.data.test_event_code || ""); } catch { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const saveCode = async () => {
    setBusy(true);
    try { await axios.put(`${API}/meta/admin/settings`, { test_event_code: code.trim() }); toast.success(code.trim() ? "Código de teste ativo — eventos aparecem em 'Testar eventos'" : "Código de teste removido (modo produção)"); load(); }
    catch { toast.error("Erro ao salvar"); }
    setBusy(false);
  };
  const sendTest = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/meta/admin/test-event`);
      if (r.data.ok) toast.success(`Evento de teste aceito pela Meta (events_received: ${r.data.response?.events_received})`, { description: `event_id ${r.data.event_id}` });
      else toast.error(`Meta recusou: ${r.data.error || r.data.status}`);
      load();
    } catch { toast.error("Erro ao enviar"); }
    setBusy(false);
  };

  const names = s?.by_name || {};
  return (
    <Card className="p-4" data-testid="meta-pixel-card">
      <div className="flex flex-wrap items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-blue-600/10 text-blue-600 flex items-center justify-center"><Facebook className="w-5 h-5" /></div>
        <div className="flex-1 min-w-[220px]">
          <div className="font-semibold text-sm">Meta Pixel · Conversions API</div>
          <div className="text-xs text-muted-foreground" data-testid="meta-pixel-status">
            {s ? <>Pixel <b>{s.pixel_id}</b> · CAPI {s.capi_configured ? "ativo" : "sem token"} · {s.sent} enviados / {s.failed} falhas · ViewContent {names.ViewContent || 0} · InitiateCheckout {names.InitiateCheckout || 0} · Purchase {names.Purchase || 0}</> : "Carregando…"}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Código 'Testar eventos' (ex.: TEST12345)" className="w-64 h-8 font-mono" data-testid="meta-test-code-input" />
          <Button size="sm" variant="outline" onClick={saveCode} disabled={busy || code === (s?.test_event_code || "")} data-testid="meta-test-code-save"><Save className="w-4 h-4 mr-1" /> Salvar</Button>
        </div>
        <Button size="sm" onClick={sendTest} disabled={busy || !s?.capi_configured} data-testid="meta-send-test">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-1" /> Enviar evento de teste</>}
        </Button>
      </div>
      {s?.test_event_code && <div className="mt-2 text-[11px] text-amber-600" data-testid="meta-test-mode">Modo teste ativo ({s.test_event_code}) — apague o código antes de ir para produção.</div>}
      {s?.last?.length > 0 && (
        <div className="mt-3 text-xs text-muted-foreground space-y-0.5 max-h-28 overflow-y-auto" data-testid="meta-last-events">
          {s.last.slice(0, 6).map((e) => <div key={e.event_id} className="truncate">• {e.event_name} · {e.event_id} · <span className={e.status === "sent" ? "text-emerald-600" : e.status === "failed" ? "text-red-600" : ""}>{e.status}</span>{e.error ? ` — ${e.error.slice(0, 80)}` : ""}</div>)}
        </div>
      )}
    </Card>
  );
}
